import LocationModalForm from './LocationModalForm';
export default LocationModalForm;
